export default __webpack_public_path__ + "static/media/peterwind.8c43ee7b.pdf";